module.exports = __webpack_public_path__ + "a87372020610a448e9431df74f098c1b.svg";